
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import NoImageAvailable from './no-image-available.vue';

@Options({
  components: {
    NoImageAvailable,
  },
})
export default class ImageContainer extends Vue {
  @Prop() imageUrl?: string;
}
